import React, { ReactElement, PropsWithChildren, CSSProperties } from 'react';

import COLORS from '~/constants/colors';
import { FONT_SIZES, FONT_WEIGHTS } from '~/constants/typography';

interface SubtextProps {
  color?: string;
  style?: CSSProperties;
}

function Subtext({
  color = COLORS.waikawaGray,
  style,
  children,
}: PropsWithChildren<SubtextProps>): ReactElement {
  const subtextStyle = {
    display: 'block',
    margin: '0.25em 0 0 0.25em',
    fontSize: FONT_SIZES.subtext,
    fontWeight: FONT_WEIGHTS.normal,
    color,
    textAlign: 'left' as const,
    ...style,
  };

  return <span style={subtextStyle}>{children}</span>;
}

export default Subtext;
